import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import ImageFeatures from '../components/ImageFeatures';
import { useFilterContext } from '../context/FilterContext';
import { useOutletContext } from 'react-router-dom';

interface ImageComparisonContext {
  imageStartDate: Date | null;
  imageEndDate: Date | null;
  [key: string]: any;
}

const ImageComparison: React.FC = () => {
  const { setUseDefaultFilters } = useFilterContext();
  const { imageStartDate, imageEndDate } = useOutletContext<ImageComparisonContext>();

  // Set useDefaultFilters to false when this component mounts
  useEffect(() => {
    setUseDefaultFilters(false);

    // Reset to default when unmounting
    return () => {
      setUseDefaultFilters(true);
    };
  }, [setUseDefaultFilters]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: '80ch', mt: -1 }}>
        See which visual features appear in each brand's images and how they perform. Pick a different brand in each panel to compare them.
      </Typography>

      <ImageFeatures
        title="Top Image Features"
        startDate={imageStartDate}
        endDate={imageEndDate}
        key={`features-a-${imageStartDate?.toISOString()}-${imageEndDate?.toISOString()}`}
      />
      <ImageFeatures
        title="Compare Another Brand"
        defaultBrandIndex={1}
        startDate={imageStartDate}
        endDate={imageEndDate}
        key={`features-b-${imageStartDate?.toISOString()}-${imageEndDate?.toISOString()}`}
      />
    </Box>
  );
};

export default ImageComparison;
